import { Document, Font, Image, Page, Text, View } from '@react-pdf/renderer'
import React, { useMemo } from 'react'
//@ts-ignore
import font from '../../assets/fonts/OpenSauceSans-Bold.ttf'
//@ts-ignore
import fontRegular from '../../assets/fonts/OpenSauceSans-Regular.ttf'
import { formatPipe, transformDate } from '../../utils/utils'

const ISLRWithholdingPdf: React.FC<any> = ({
  bodyValues = {},
  infoAccount = {},
}) => {
  Font.register({
    family: 'Open Sans',
    fonts: [{ src: font }],
  })

  Font.register({
    family: 'Open Sans-normal',
    fonts: [{ src: fontRegular }],
  })

  const date = useMemo(() => {
    return transformDate(new Date(bodyValues.date).toISOString())
  }, [bodyValues.date])

  const getDateInfo = () => {
    const year = new Date(bodyValues.date).getFullYear()
    const month = new Date(bodyValues.date).getMonth() + 1
    return `Año: ${year} Mes: ${month}`
  }

  return (
    <Document title={`Retención_islr_${bodyValues?.bill?.code}`}>
      <Page size="A4" orientation="landscape" style={{ padding: 30 }}>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <View style={{ width: '10%', alignItems: 'flex-start' }}>
            {infoAccount?.image && (
              <Image
                style={{
                  width: 150,
                  height: 80,
                  objectFit: 'contain',
                }}
                src={infoAccount?.image}
              />
            )}
          </View>

          <View
            style={{
              width: '40%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: 5,
            }}
          >
            <View style={{ display: 'flex', flexDirection: 'row' }}>
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: 'Open Sans',
                  marginRight: 5,
                }}
              >
                Nro de Comprobante:
              </Text>

              <Text style={{ fontSize: 10, fontFamily: 'Open Sans-normal' }}>
                {bodyValues?.islrWithholding?.voucher_number}
              </Text>
            </View>

            <View style={{ display: 'flex', flexDirection: 'row' }}>
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: 'Open Sans',
                  marginRight: 5,
                }}
              >
                Fecha:
              </Text>

              <Text style={{ fontSize: 10, fontFamily: 'Open Sans-normal' }}>
                {date}
              </Text>
            </View>

            <View style={{ display: 'flex', flexDirection: 'row' }}>
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: 'Open Sans',
                  marginRight: 5,
                }}
              >
                Periodo Fiscal:
              </Text>

              <Text style={{ fontSize: 10, fontFamily: 'Open Sans-normal' }}>
                {getDateInfo()}
              </Text>
            </View>
          </View>
        </View>

        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 7,
            marginTop: 10,
          }}
        >
          <Text
            style={{
              fontSize: 12,
              fontFamily: 'Open Sans',
              fontWeight: 'bold',
            }}
          >
            Comprobante de Retención de ISLR
          </Text>

          <Text style={{ fontSize: 10, fontFamily: 'Open Sans-normal' }}>
            Providencia Administrativa N° SNAT/2009/0095 de fecha 22/09/2009
          </Text>
        </View>

        <View
          style={{
            marginTop: 20,
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
          }}
        >
          <View style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
            <View
              style={{
                width: '50%',
                backgroundColor: '#f2f2f2',
                padding: 5,
                height: 30,
                display: 'flex',
                flexDirection: 'row',
                gap: 3,
              }}
            >
              <Text style={{ fontSize: 8, fontFamily: 'Open Sans' }}>
                Nombre o Razón Social del Agente de Retención:
              </Text>
              <Text style={{ fontSize: 8, fontFamily: 'Open Sans-normal' }}>
                {infoAccount?.businessSocial}
              </Text>
            </View>
            <View
              style={{
                width: '50%',
                backgroundColor: '#f2f2f2',
                padding: 5,
                height: 30,
                display: 'flex',
                flexDirection: 'row',
                gap: 3,
              }}
            >
              <Text style={{ fontSize: 8, fontFamily: 'Open Sans' }}>
                Registro de Información Fiscal del Agente de Retención:
              </Text>
              <Text style={{ fontSize: 8, fontFamily: 'Open Sans-normal' }}>
                {`${infoAccount?.document?.documentType} ${infoAccount?.document?.document}`}
              </Text>
            </View>
          </View>

          <View
            style={{
              backgroundColor: '#f2f2f2',
              padding: 5,
              height: 25,
              display: 'flex',
              flexDirection: 'row',
              gap: 5,
            }}
          >
            <Text style={{ fontSize: 8, fontFamily: 'Open Sans' }}>
              Dirección Fiscal del Agente de Retención:
            </Text>
            <Text style={{ fontSize: 8, fontFamily: 'Open Sans-normal' }}>
              {infoAccount?.address?.address}
            </Text>
          </View>

          <View style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
            <View
              style={{
                width: '50%',
                backgroundColor: '#f2f2f2',
                padding: 5,
                minHeight: 30,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: 2,
              }}
            >
              <Text style={{ fontSize: 8, fontFamily: 'Open Sans' }}>
                Nombre o Razón Social del Sujeto Retenido:
              </Text>
              <Text
                style={{
                  fontSize: 8,
                  fontFamily: 'Open Sans-normal',
                  width: '100%',
                }}
                wrap
              >
                {bodyValues?.provider?.businessName}
              </Text>
            </View>
            <View
              style={{
                width: '50%',
                backgroundColor: '#f2f2f2',
                padding: 5,
                height: 30,
                display: 'flex',
                flexDirection: 'row',
                gap: 3,
              }}
            >
              <Text style={{ fontSize: 8, fontFamily: 'Open Sans' }}>
                Registro de Información Fiscal del Sujeto:
              </Text>
              <Text style={{ fontSize: 8, fontFamily: 'Open Sans-normal' }}>
                {`${bodyValues?.provider?.documentType} ${bodyValues?.provider?.document}`}
              </Text>
            </View>
          </View>
        </View>

        <View style={{ marginTop: 15 }}>
          {/* Header */}
          <View style={{ flexDirection: 'row', border: '1px solid #bfc9e0' }}>
            {[
              'Oper. Nro.',
              'Fecha del documento',
              'Número de factura',
              'Número de control',
              'Base imponible',
              '% Retención',
              'Monto retenido',
            ].map((header, idx) => (
              <View
                key={idx}
                style={{
                  flex: 1,
                  borderRight: idx !== 6 ? '1px solid #bfc9e0' : 'none',
                  padding: 3,
                  backgroundColor: '#eaf0fb',
                  alignItems: 'center',
                }}
              >
                <Text
                  style={{
                    fontSize: 7,
                    fontFamily: 'Open Sans',
                    textAlign: 'center',
                  }}
                >
                  {header}
                </Text>
              </View>
            ))}
          </View>
          {/* Data Row */}
          <View
            style={{
              flexDirection: 'row',
              border: '1px solid #bfc9e0',
              borderTop: 'none',
            }}
          >
            {[
              '1',
              date,
              bodyValues?.bill?.code,
              bodyValues?.bill?.control,
              formatPipe(bodyValues?.islrWithholding?.tax_base || 0),
              `${bodyValues?.islrWithholding?.withholding_percentage || 0}%`,
              formatPipe(bodyValues?.islrWithholding?.amount_withheld || 0),
            ].map((cell, idx) => (
              <View
                key={idx}
                style={{
                  flex: 1,
                  borderRight: idx !== 6 ? '1px solid #bfc9e0' : 'none',
                  padding: 3,
                  alignItems: 'center',
                }}
              >
                <Text
                  style={{
                    fontSize: 7,
                    fontFamily: 'Open Sans-normal',
                    textAlign: 'center',
                  }}
                >
                  {cell}
                </Text>
              </View>
            ))}
          </View>
        </View>

        <View style={{ marginTop: 15 }}>
          <Text style={{ fontSize: 10, fontFamily: 'Open Sans-normal' }}>
            ** Este comprobante se emite en función de lo establecido en el
            artículo 1 de la Providencia Administrativa N° SNAT/2009/0095 de
            fecha 22/09/2009
          </Text>
        </View>

        <View
          style={{
            marginTop: 40,
          }}
        >
          {/* Signature boxes section */}
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginBottom: 15,
            }}
          >
            {/* FECHA DE EMISIÓN */}
            <View
              style={{
                width: '32%',
                minHeight: 80,
                backgroundColor: '#f7f7f7',
                borderRadius: 6,
                border: '1px solid #e0e0e0',
                padding: 10,
                alignItems: 'center',
                justifyContent: 'flex-start',
              }}
            >
              <Text
                style={{
                  fontSize: 11,
                  fontFamily: 'Open Sans',
                  fontWeight: 'bold',
                  color: '#535b6b',
                  marginBottom: 5,
                }}
              >
                FECHA DE EMISIÓN
              </Text>

              <Text
                style={{
                  fontSize: 11,
                  fontFamily: 'Open Sans',
                  fontWeight: 'bold',
                  color: '#535b6b',
                  marginTop: 5,
                }}
              >
                {date}
              </Text>
            </View>
            {/* FECHA DE ENTREGA */}
            <View
              style={{
                width: '32%',
                minHeight: 80,
                backgroundColor: '#f7f7f7',
                borderRadius: 6,
                border: '1px solid #e0e0e0',
                padding: 10,
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
              }}
            >
              <Text
                style={{
                  fontSize: 11,
                  fontFamily: 'Open Sans',
                  fontWeight: 'bold',
                  color: '#535b6b',
                  marginBottom: 5,
                }}
              >
                FECHA DE ENTREGA
              </Text>
              <Text
                style={{
                  fontSize: 9,
                  fontFamily: 'Open Sans-normal',
                  marginTop: 5,
                }}
              >
                Fecha:
              </Text>
              <Text style={{ fontSize: 9, fontFamily: 'Open Sans-normal' }}>
                Firma:
              </Text>
              <Text style={{ fontSize: 9, fontFamily: 'Open Sans-normal' }}>
                C.I o R.I.F:
              </Text>
            </View>
            {/* AGENTE DE RETENCIÓN */}
            <View
              style={{
                width: '32%',
                minHeight: 80,
                backgroundColor: '#f7f7f7',
                borderRadius: 6,
                border: '1px solid #e0e0e0',
                padding: 10,
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              <Text
                style={{
                  fontSize: 11,
                  fontFamily: 'Open Sans',
                  fontWeight: 'bold',
                  color: '#535b6b',
                  marginBottom: 5,
                }}
              >
                AGENTE DE RETENCIÓN
              </Text>
              <Text
                style={{
                  fontSize: 9,
                  fontFamily: 'Open Sans-normal',
                  marginTop: 30,
                }}
              >
                (Sello, Fecha y Firma)
              </Text>
            </View>
          </View>

          {/* Legal text */}
          <View
            style={{
              backgroundColor: '#f7f7f7',
              borderRadius: 6,
              border: '1px solid #e0e0e0',
              padding: 10,
              alignItems: 'flex-start',
            }}
          >
            <Text
              style={{
                fontSize: 9,
                fontFamily: 'Open Sans',
                fontWeight: 'bold',
                color: '#535b6b',
              }}
            >
              Ley de ISLR - Art. 84{' '}
              <Text
                style={{
                  fontFamily: 'Open Sans-normal',
                  fontWeight: 'normal',
                  color: '#535b6b',
                }}
              >
                "La Administración Tributaria, mediante providencia de carácter
                general, podrá designar como responsables del pago del impuesto
                en calidad de agentes de retención o percepción, así como fijar
                porcentajes de retención y percepción, a quienes por sus
                funciones públicas o por razón de sus actividades privadas
                intervengan en operaciones gravadas con el impuesto establecido
                en este Decreto con Rango, Valor y Fuerza de Ley…"
              </Text>
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  )
}

export default ISLRWithholdingPdf
